import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from 'E:/pocket-tool/.pocket-doc/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from "../../src/components/InitMenu";
import React, {useRef, useState} from "react";
import SelectInput from "pocko-ui/SelectInput";
import 'pocko-ui/SelectInput/index.css';
export const Demo = () => {
  const dropdown = [{
    id: 1,
    name: "1",
    value: "1"
  }, {
    id: 2,
    name: "2",
    value: "2"
  }, {
    id: 3,
    name: "3",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState("");
  const [defaultValue2, setDefaultValue2] = useState("");
  const [defaultValue3, setDefaultValue3] = useState("");
  return <>
      <SelectInput id="id" name="name" dropdownRender={dropdown} onChange={i => {
    setDefaultValue(i.value);
  }} defaultValue={defaultValue} wrapperClassName="mt-2" manualSearchTrigger={false}></SelectInput>

      <SelectInput id="id" name="name" dropdownRender={dropdown} onChange={i => {
    setDefaultValue2(i.value);
  }} defaultValue={defaultValue2} wrapperClassName="mt-2" cleanTrigger={{
    valid: true,
    cleanValueLabel: "Clean",
    cleanFunc: () => {
      setDefaultValue2("");
    }
  }}></SelectInput>

      <SelectInput id="id" name="name" dropdownRender={dropdown} onChange={i => {
    setDefaultValue3(i.value);
  }} defaultValue={defaultValue3} wrapperClassName="mt-2" cleanTrigger={{
    valid: true,
    cleanValueLabel: "Clean",
    cleanFunc: () => {
      setDefaultValue3("");
    }
  }} manualSearchTrigger={true}></SelectInput>
    </>;
};
export const DemoMul = () => {
  const dropdown = [{
    id: 1,
    name: "1",
    value: "1"
  }, {
    id: 2,
    name: "2",
    value: "2"
  }, {
    id: 3,
    name: "3",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState([]);
  return <>
      <SelectInput type="MULTI" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i);
  }} defaultValue={defaultValue}></SelectInput>
    </>;
};
export const DemoMulTagRemove = () => {
  const dropdown = [{
    id: 1,
    name: "Doctor A",
    value: "1"
  }, {
    id: 2,
    name: "Doctor B",
    value: "2"
  }, {
    id: 3,
    name: "Doctor C",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState([]);
  return <>
      <SelectInput type="MULTI" id="id" name="name" dropdownRender={dropdown} showTagRemove onChange={i => {
    console.log("change", i);
    setDefaultValue(i);
  }} onTagRemove={(removedItem, newValue) => {
    console.log("removed item:", removedItem);
    console.log("new value:", newValue);
    setDefaultValue(newValue);
  }} defaultValue={defaultValue}></SelectInput>
    </>;
};
export const DemoMulTagClick = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  const dropdown = [{
    id: 1,
    name: "Doctor A",
    value: "1"
  }, {
    id: 2,
    name: "Doctor B",
    value: "2"
  }, {
    id: 3,
    name: "Doctor C",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState([dropdown[0], dropdown[1]]);
  const [clickedTag, setClickedTag] = useState("");
  return <>
      <SelectInput type="MULTI" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log("change", i);
    setDefaultValue(i);
  }} onTagClick={(item, event) => {
    event.preventDefault();
    event.stopPropagation();
    console.log("clicked tag:", item);
    setClickedTag(item.name);
  }} defaultValue={defaultValue}></SelectInput>

      <_components.div className="mt-2 text-secondary">
        Clicked tag: {clickedTag || "-"}
      </_components.div>
    </>;
};
export const DemoPosition = () => {
  const dropdown = [{
    id: 1,
    name: "1",
    value: "1"
  }, {
    id: 2,
    name: "2",
    value: "2"
  }, {
    id: 3,
    name: "3",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState("");
  return <>
      <SelectInput label="Top" type="COMMON" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i.value ? i.value : i);
  }} defaultValue={defaultValue} dropdownPosition="top"></SelectInput>

      <SelectInput label="Bottom" type="COMMON" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i.value ? i.value : i);
  }} defaultValue={defaultValue} wrapperClassName="my-2" dropdownPosition="bottom"></SelectInput>

      <SelectInput label="Auto" type="COMMON" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i.value ? i.value : i);
  }} defaultValue={defaultValue} dropdownPosition="auto"></SelectInput>
    </>;
};
export const DemoInputValue = () => {
  const dropdown = [{
    id: 1,
    name: "1",
    value: "1"
  }, {
    id: 2,
    name: "2",
    value: "2"
  }, {
    id: 3,
    name: "3",
    value: "3"
  }];
  const [defaultValue, setDefaultValue] = useState('');
  return <>
      <SelectInput type="COMMON" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i.value ? i.value : i);
  }} defaultValue={defaultValue} isHandleInput={true}></SelectInput>
    </>;
};
export const DemoCustomizeOption = () => {
  const _components = Object.assign({
    span: "span",
    small: "small"
  }, _provideComponents());
  const dropdown = [{
    id: 1,
    name: "OIE19022",
    age: "21"
  }, {
    id: 2,
    name: "OIE19061",
    age: "22"
  }, {
    id: 3,
    name: "SWE19048",
    age: "23"
  }];
  const [defaultValue, setDefaultValue] = useState("");
  return <>
      <SelectInput type="COMMON" id="id" name="name" dropdownRender={dropdown} onChange={i => {
    console.log(i);
    setDefaultValue(i.name);
  }} defaultValue={defaultValue} renderOption={item => <>
            <_components.span>{item.name}</_components.span>
            <_components.small className="d-flex flex-wrap align-items-center gap-1 text-secondary-emphasis anes-bill-justify-between">
              <_components.span>id：{item.id}</_components.span>
              <_components.span>age{item.age}</_components.span>
            </_components.small>
          </>} manualSearchTrigger={false}></SelectInput>
    </>;
};
export const __toc = [{
  depth: 4,
  value: "General",
  id: "general"
}, {
  depth: 4,
  value: "Multiple Selection",
  id: "multiple-selection"
}, {
  depth: 4,
  value: "Tag Removable Multiple Selection",
  id: "tag-removable-multiple-selection"
}, {
  depth: 4,
  value: "Tag Click Multiple Selection",
  id: "tag-click-multiple-selection"
}, {
  depth: 4,
  value: "Choose Dropdown Position",
  id: "choose-dropdown-position"
}, {
  depth: 4,
  value: "Input Value as Selected Value",
  id: "input-value-as-selected-value"
}, {
  depth: 4,
  value: "Customize Option Content",
  id: "customize-option-content"
}, {
  depth: 4,
  value: "API",
  id: "api"
}, {
  depth: 5,
  value: "SelectInput",
  id: "selectinput"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h4: "h4",
    p: "p",
    strong: "strong",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    h5: "h5",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"SelectInput"}</_components.h1>{"\n"}{"\n"}<_components.h4 id="general">{"General"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p><_components.strong>{"SelectInput"}</_components.strong><br />{"\r\nA retrievable dropdown menu used to display options."}</_components.p>{"\n"}{"\n"}<Demo />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue3"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue2}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cleanTrigger"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    valid"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    cleanValueLabel"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Clean\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cleanFunc"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue3"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue3}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cleanTrigger"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    valid"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    cleanValueLabel"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Clean\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cleanFunc"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue3"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"manualSearchTrigger"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// When true, disables automatic search on focus or initialization; search must be triggered manually."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="multiple-selection">{"Multiple Selection"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"Multiple selection, selecting from existing items."}</_components.p>{"\n"}{"\n"}<DemoMul />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// *** the type must be array"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"MULTI\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="tag-removable-multiple-selection">{"Tag Removable Multiple Selection"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"Multiple selection with removable tags. Users can quickly remove selected items directly from the input area."}</_components.p>{"\n"}{"\n"}<DemoMulTagRemove />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor A\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor B\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor C\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"3\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"Demo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"() {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"MULTI\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showTagRemove"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"change\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onTagRemove"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(removedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" newValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"removed item:\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" removedItem);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"new value:\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" newValue);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(newValue);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    ></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="tag-click-multiple-selection">{"Tag Click Multiple Selection"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"Multiple selection with selected tag click callback. Use "}<_components.code>{"onTagClick"}</_components.code>{" when selected tags need to trigger a detail view or custom action."}</_components.p>{"\n"}{"\n"}<DemoMulTagClick />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor A\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor B\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Doctor C\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"3\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"Demo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"() {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>(["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    dropdown["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    dropdown["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  ]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"clickedTag"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setClickedTag"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"MULTI\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"change\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onTagClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" event"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLSpanElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"event"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"event"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".stopPropagation"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"clicked tag:\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setClickedTag"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".name);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      ></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-2 text-secondary\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        Clicked tag: {clickedTag "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"||"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"-\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="choose-dropdown-position">{"Choose Dropdown Position"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"Select the location where the dropdown box appears"}</_components.p>{"\n"}{"\n"}<DemoPosition />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"COMMON\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownPosition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"top\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Bottom\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"COMMON\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"my-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownPosition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"bottom\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Auto\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"COMMON\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownPosition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"auto\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="input-value-as-selected-value">{"Input Value as Selected Value"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"Using the input value as the selected value"}</_components.p>{"\n"}{"\n"}<DemoInputValue />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'2'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"COMMON\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"           "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"           "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"isHandleInput"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="customize-option-content">{"Customize Option Content"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p>{"You can customize the content of the dropdown options"}</_components.p>{"\n"}{"\n"}<DemoCustomizeOption />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/SelectInput\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dropdown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19022\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" age"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"20\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19061\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" age"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"22\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"SWE19048\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" age"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"21\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"COMMON\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"name\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dropdownRender"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{dropdown}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(i);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setDefaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".name);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{defaultValue}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"renderOption"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".name}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"d-flex flex-wrap align-items-center gap-1 text-secondary-emphasis anes-bill-justify-between\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">id：{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">age{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".age}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"span"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  )}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"manualSearchTrigger"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"SelectInput"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="api">{"API"}</_components.h4>{"\n"}<hr />{"\n"}<_components.h5 id="selectinput">{"SelectInput"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" SelectInput "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/SelectInput'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/SelectInput/index.css'"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"wrapperClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"position: relative"}</_components.td><_components.td>{"The class name of the control wrapper."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"wrapperContentInputClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"position: relative; form-control"}</_components.td><_components.td>{"The class name of the control."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"popupMenuClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"position-absolute shadow border rounded..."}</_components.td><_components.td>{"The class name of the popup menu."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"lable"}</_components.code></_components.td><_components.td>{"string | React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Customize left label render"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"type"}</_components.code></_components.td><_components.td>{"\"COMMON\" | \"MULTI\""}</_components.td><_components.td>{"'COMMON'"}</_components.td><_components.td>{"Set mode of Select"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"inputWidth"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"'auto'"}</_components.td><_components.td>{"Custom width of Select"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"id"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The ID of the object data."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"name"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The Name of the object data."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"kbcode"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"'kb_code'"}</_components.td><_components.td>{"The keyboard code of the object data."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dropdownRender"}</_components.code></_components.td><_components.td>{"any[]"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Select options."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dropdownPosition"}</_components.code></_components.td><_components.td>{"\"top\" | \"bottom\" | \"auto\""}</_components.td><_components.td>{"'auto'"}</_components.td><_components.td>{"Select the location where the dropdown appears."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onDropdownHide"}</_components.code></_components.td><_components.td>{"() => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Callback function that is triggered when the dropdown menu is hidden (e.g. click outside, option selected, or programmatically closed)."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"renderOption"}</_components.code></_components.td><_components.td>{"(item: any) => React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Function to customize how each option is rendered. Receives the item as a parameter."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"defaultValue"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Initial selected option."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"cleanTrigger"}</_components.code></_components.td><_components.td>{"CleanTriggerConfig"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Configuration for the clear button at the top of the dropdown list. Contains:"}</_components.td><_components.td /></_components.tr><_components.tr><_components.td /><_components.td /><_components.td /><_components.td>{"- "}<_components.code>{"valid"}</_components.code>{": A boolean to enable or disable the clear button."}</_components.td><_components.td /></_components.tr><_components.tr><_components.td /><_components.td /><_components.td /><_components.td>{"- "}<_components.code>{"cleanValueLabel"}</_components.code>{": Optional label for the clear button."}</_components.td><_components.td /></_components.tr><_components.tr><_components.td /><_components.td /><_components.td /><_components.td>{"- "}<_components.code>{"cleanFunc"}</_components.code>{": Optional custom function to execute when the clear button is clicked."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"index"}</_components.code></_components.td><_components.td>{"string | number | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"When using a list, determine which row the component is on in the list."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"zIndex"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"1101"}</_components.td><_components.td>{"Set the depth value of the control to control the display of the pop-up layer appear above. Please set it when multiple controls are used at the same time."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onChange"}</_components.code></_components.td><_components.td>{"Function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Called when select an option or input value change."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onKeyDown"}</_components.code></_components.td><_components.td>{"Function | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The callback function that is triggered when keyboard is pressed."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"isDisable"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Whether to disable the input."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"isHandleInput"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Using the input value as the selected value."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"isDisableBodyScroll"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Whether disable the body scroll. "}<_components.code>{"*you need npm i body-scroll-lock*"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dataService"}</_components.code></_components.td><_components.td>{"any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Add a service class as a parameter to interact with external data sources or APIs."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dataServiceFunction"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The name of the function to be called from the service class."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dataServiceFunctionParams"}</_components.code></_components.td><_components.td>{"any[]"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"An array of parameters for the function call. "}<_components.strong>{"Important"}</_components.strong>{": If the array contains "}<_components.code>{"$QUERY_STRING"}</_components.code>{", the entered value will be treated as a parameter and passed out."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"dataServiceRetrieve"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Is this service class function a retrieval class. "}<_components.strong>{"Important:"}</_components.strong>{" If the field is set to "}<_components.code>{"true"}</_components.code>{", the server's retrieval interface will be called every time the input is entered. If it is not set to "}<_components.code>{"true"}</_components.code>{", the interface will only be called once when the mouse is clicked."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"manualSearchTrigger"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"When set to "}<_components.code>{"true"}</_components.code>{", disables automatic search on focus or initialization. Search must be triggered manually (e.g., by a button). Useful for scenarios like "}<_components.code>{"*input first, then search.*"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"showTagRemove"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Whether to display the remove button ("}<_components.code>{"✕"}</_components.code>{") for selected items in "}<_components.code>{"MULTI"}</_components.code>{" mode. When enabled, users can quickly remove selected tags directly from the input area."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onTagRemove"}</_components.code></_components.td><_components.td>{"(removedItem: any, newValue: any[], index?: any) => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Callback function triggered when a selected tag is removed by clicking the remove button ("}<_components.code>{"✕"}</_components.code>{"). Returns the removed item, the updated value list, and the optional row index."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onTagClick"}</_components.code></_components.td><_components.td>{"(item: any, event: React.MouseEvent<HTMLSpanElement>, index?: any) => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Callback function triggered when a selected tag text is clicked in "}<_components.code>{"MULTI"}</_components.code>{" mode. Returns the clicked item, mouse event, and the optional row index."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Web-Elements/SelectInput.html.mdx","route":"/Web-Elements/SelectInput.html","timestamp":1780639139000,"pageMap":[{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"Meta","data":{"Input.html":"Input🔥","Checkbox.html":"Checkbox","Radio.html":"Radio"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"MdxPage","name":"index","route":"/"},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"DropdownMenu"}}]},{"kind":"Folder","name":"Other","route":"/Other","children":[{"kind":"MdxPage","name":"EmptyNotice.html","route":"/Other/EmptyNotice.html"},{"kind":"MdxPage","name":"Popovers.html","route":"/Other/Popovers.html"},{"kind":"Meta","data":{"EmptyNotice.html":"EmptyNotice🌈","Popovers.html":"Popovers🔈"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Notification.html","route":"/Web-Elements/Notification.html"},{"kind":"MdxPage","name":"SelectInput.html","route":"/Web-Elements/SelectInput.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"ToolTips.html","route":"/Web-Elements/ToolTips.html"},{"kind":"MdxPage","name":"Trees.html","route":"/Web-Elements/Trees.html"},{"kind":"Meta","data":{"ModalDialog.html":"ModalDialog🔥","SelectInput.html":"SelectInput🔥","ToolTips.html":"ToolTips","Table.html":"Table🔥","Trees.html":"Trees","Notification.html":"Notification"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":{"title":"Getting-Started"},"--":{"type":"separator","title":"Components"},"Web-Elements":{"title":"Web Elements"},"Forms":{"title":"Forms"},"Navigation":{"title":"Navigation"},"Other":{"title":"Other"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/chennkaibin/pocko-ui","newWindow":true}}}],"flexsearch":{"codeblocks":true},"title":"SelectInput",headings:__toc},
  pageNextRoute: "/Web-Elements/SelectInput.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)